export default [
  {
    path: "/crm/customers",
    name: "Customers",
    component: () => import("@/pages/crm/CustomersPage.vue"),
  },
  {
    path: "/crm/customers/new",
    name: "NewCustomer",
    component: () => import("@/form/crm/NewCustomer.vue"),
  }
];